import React, { useState } from 'react';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../Header/Header';
import { Table } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { useContext } from 'react';
import { UserContext } from '../../App';

const Checkout = () => {

    const {bookId} = useParams();

    const [signInUser, setSignInUser]=useContext(UserContext);
    

    const [book,setBook] = useState([]);
    
    const{name,_id,imageUrl,price,author} = book;


    useEffect(() => {
        fetch('https://cryptic-plains-44743.herokuapp.com/books')
            .then(res => res.json())
            .then(data => {
                //console.log(data);
                const sellectedBook = data.find((book => book._id === bookId))
                setBook(sellectedBook)
            })
    }, [bookId])
    console.log(book);

const newBook = {
    name: name,
    price: price,
    image: imageUrl
}

console.log("newProduct", newBook)

const handleCheek = () => {

    const bookInfo = { ...signInUser, ...newBook, date: new Date() }
    //console.log(productInfo);

    fetch('https://cryptic-plains-44743.herokuapp.com/addOrder', {
        method: 'POST',
        headers: {
            'Content-type': 'application/json'
        },
        body: JSON.stringify(bookInfo)
    })
        .then(res => res.json())
        .then(data => {
            if (data) {
                alert('Order Succesfully');
            }
        })

}



    return (
        <div className="container">
        <Header></Header>

        <h3>  Your <b> {bookId} </b>order</h3>


        <Table responsive="sm">
                    <thead >
                        <tr>
                            <th>Book Name</th>
                            <th>Quantity</th>
                            <th>Price</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><strong>{name}</strong></td>
                            <td>1</td>
                            <td><strong>${price}</strong></td>
                        </tr>
                        <tr>
                            <td><strong>Total</strong></td>
                            <td></td>
                            <td><strong>${price} </strong></td>
                        </tr>
                    </tbody>
                </Table>


                <Link to='/orders'><button onClick={handleCheek} style={{ marginLeft: 'auto' }} className='btn btn-success '>CheekOut</button></Link>

        
            
        </div>
    );
};

export default Checkout;